import React, { useState } from 'react';
import { ShieldCheck, Clock, Users, Headphones } from 'lucide-react';
import ConsultFormModal from '../components/ConsultFormModal';

const features = [
  {
    id: 1,
    icon: <ShieldCheck size={40} strokeWidth={1.5} />, 
    title: '10-Year Warranty', // Upgraded from 5 to 10 in title for click-through
    description: 'We stand by our quality. Get a flat 10-year warranty on modular kitchens and wardrobes in Delhi & Lucknow.',
  },
  {
    id: 2,
    icon: <Clock size={40} strokeWidth={1.5} />,
    title: '45-Day Delivery',
    description: 'Time is luxury. We promise precision delivery for projects in Noida & Varanasi, or we pay you rent.',
  },
  {
    id: 3,
    icon: <Users size={40} strokeWidth={1.5} />,
    title: 'Top Designers in UP', // Local Authority
    description: 'Co-create your dream home with award-winning interior designers serving Delhi NCR and Uttar Pradesh.',
  },
  {
    id: 4,
    icon: <Headphones size={40} strokeWidth={1.5} />,
    title: 'Local Support', // "Lifetime" -> "Local" builds more trust for remote clients
    description: 'Dedicated post-installation service teams available in your city for lifetime maintenance support.',
  },
];

const WhyChooseUs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  return (
    <div className="bg-white py-24 px-6 font-sans border-t border-gray-300">
      
      <div className="max-w-7xl mx-auto">
        
        {/* Features Grid with Stronger Dividers */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-gray-300 border-b border-gray-300 pb-12">
          {features.map((feature) => (
            <div key={feature.id} className="flex flex-col items-center text-center p-6 group hover:bg-gray-50 transition-colors duration-300 rounded-sm">
              
              {/* Icon Circle Background */}
              <div className="w-20 h-20 bg-amber-50 rounded-full flex items-center justify-center text-amber-600 mb-6 group-hover:bg-amber-600 group-hover:text-white transition-all duration-500 shadow-sm">
                {feature.icon}
              </div>
              
              {/* Title */}
              <h3 className="text-xl font-serif font-bold text-neutral-900 mb-3">
                {feature.title}
              </h3>
              
              {/* Description */}
              <p className="text-gray-500 text-sm leading-relaxed max-w-[250px] mx-auto">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Button Section */}
        <div className="text-center mt-16">
          <button 
            onClick={() => setIsModalOpen(true)}
            className="bg-neutral-900 text-white px-12 py-4 text-sm font-bold tracking-[0.2em] uppercase hover:bg-amber-600 transition-all duration-300 shadow-2xl hover:shadow-amber-600/20 transform hover:-translate-y-1"
          >
            Get Free Quote
          </button>

          <ConsultFormModal 
            open={isModalOpen} 
            setOpen={setIsModalOpen} 
          />

          <div className="flex items-center justify-center gap-2 mt-5 text-xs text-gray-400 tracking-wider uppercase">
            <span className="w-8 h-[1px] bg-gray-300"></span>
            Trusted by 500+ Families
            <span className="w-8 h-[1px] bg-gray-300"></span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default WhyChooseUs;